import React, {useEffect, useMemo, useState} from 'react';
import ReactGA from 'react-ga';
import {connect} from 'react-redux';
import {Route, RouteProps} from 'react-router-dom';
import {compose} from 'redux';
import '../';
import {ITenant} from '../App';
import AppWrapper from '../components/app-wrapper';
import NewPageLoader from '../components/page-loader/NewPageLoader';
import {AuthConsumer} from '../providers/AuthProvider';
import {Store} from '../store';
import {functionalitiesAliasMap} from '../util/strings';
import {isObjectEmpty} from '../util/utility';
import PageMaintenance from '../components/page-maintenance';

interface ProtectedRouteProps extends RouteProps {
  component: any;
  functionality?: any;
  labels: any;
  disableReimbursementRequestButton: boolean;
  busFuncMapDefault: any;
  tenant: ITenant;
  isUnderMaintenance: boolean;
}

const ProtectedRoute = (props: ProtectedRouteProps) => {
  const {
    component: Component,
    functionality,
    path,
    disableReimbursementRequestButton,
    tenant,
    busFuncMapDefault,
    isUnderMaintenance,
    ...rest
  } = props;
  const [showRoute, setShowRoute] = useState<boolean>(true);
  const [updateMenu, setUpdateMenu] = useState(false);
  const [loadedIsUnderMaintenance, setLoadedIsUnderMaintenance] =
    useState(false);
  const [loadedIsUnderMaintenanceKey, setLoadedIsUnderMaintenanceKey] =
    useState(0);

  const [googleaAnalyticsIsVisible, setGoogleaAnalyticsIsVisible] = useState(
    busFuncMapDefault?.[functionalitiesAliasMap.googleanalyticsgtm]
  );

  const isConsentLocation =
    window.location.pathname === '/politica-marketing' ||
    window.location.pathname === '/atualizar-termos' ||
    window.location.pathname === '/tratamento-dados' ||
    window.location.pathname === '/informacao-seguro' ||
    window.location.pathname === '/confirmar-dados-pessoais';

  const checkFunctionality = () => {
    const selectedBu = Store.getState().selectedBu.value.buId;
    const busFuncMap = Store.getState().busFuncMap.value;
    if (functionality && busFuncMap && !isObjectEmpty(busFuncMap)) {
      const activeFunctionality = busFuncMap[selectedBu]?.filter(
        (func: any) =>
          func?.featureTemplateAlias === functionality && func?.isVisible
      );
      setShowRoute(activeFunctionality?.length > 0);
    }
    if (path == '/historico-reembolsos/pedido-reembolso') {
      setShowRoute(!disableReimbursementRequestButton);
    }
  };

  const checkRedirectToHomepage = () => {
    if (!showRoute) {
      window.location.replace('/inicio');
    }
  };

  useMemo(() => {
    checkFunctionality();
  }, [Store.getState().selectedBu.value.famId]);

  useEffect(() => {
    checkRedirectToHomepage();
  }, [showRoute]);

  useEffect(() => {
    setUpdateMenu(!updateMenu);
  }, [props.labels]);

  useEffect(() => {
    if (isUnderMaintenance !== null) {
      setLoadedIsUnderMaintenance(true);
      setLoadedIsUnderMaintenanceKey(loadedIsUnderMaintenanceKey + 1);
    }
  }, [isUnderMaintenance]);

  const impersonateAuth = localStorage.getItem('logged_in_by_url') === 'true';

  const renderFn = (routeProps: any) => {
    return (
      loadedIsUnderMaintenance && (
        <AuthConsumer>
          {({isAuthenticated, signinRedirect}) => {
            if (
              (!!Component && isAuthenticated()) ||
              (!!Component && impersonateAuth)
            ) {
              return !isConsentLocation ? (
                <AppWrapper updateMenu={updateMenu}>
                  <Component {...routeProps} />
                </AppWrapper>
              ) : (
                <Component {...routeProps} />
              );
            } else {
              if (isUnderMaintenance != false) {
                if (isUnderMaintenance) {
                  return (
                    <div className="loading-page-container">
                      <PageMaintenance />
                    </div>
                  );
                } else {
                  return (
                    <div className="loading-page-container">
                      <NewPageLoader />
                    </div>
                  );
                }
              } else {
                signinRedirect();
              }
              return (
                <div className="loading-page-container">
                  <NewPageLoader />
                </div>
              );
            }
          }}
        </AuthConsumer>
      )
    );
  };

  useEffect(() => {
    // verify this line if the functionality is disabled
    showRoute &&
      googleaAnalyticsIsVisible &&
      ReactGA.pageview(window.location.pathname + window.location.search);
  }, [showRoute]);

  return (
    <>
      {showRoute || !functionality ? (
        <Route {...rest} key={loadedIsUnderMaintenanceKey} render={renderFn} />
      ) : (
        <></>
      )}
    </>
  );
};

const mapStateToProps = ({
  strings,
  disableReimbursementRequestButton,
  tenant,
  busFuncMapDefault,
  isUnderMaintenance,
}: any) => ({
  labels: strings.value.pt,
  disableReimbursementRequestButton: disableReimbursementRequestButton.value,
  tenant: tenant.value,
  busFuncMapDefault: busFuncMapDefault.value,
  isUnderMaintenance: isUnderMaintenance.value,
});

export default compose(connect(mapStateToProps)(ProtectedRoute));
